import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-toggle-switch-box',
  templateUrl: './toggle-switch-box.component.html',
  styleUrls: ['./toggle-switch-box.component.scss']
})
export class ToggleSwitchBoxComponent implements OnChanges {
  @Input() inputValue: boolean;
  @Input() isReadOnly: boolean;
  @Input() Label: boolean;
  @Input() LabelRight: any;
  @Input() LabelTop: any;
  @Input() disabled: boolean;
  @Output() outputKeyword: EventEmitter<string> = new EventEmitter();

  onSwitchChange(e) {
    this.outputKeyword.emit(e.checked);
  }

  ngOnChanges(changes: SimpleChanges): void {
    let inputValue = changes.inputValue && changes.inputValue.currentValue
    if (!!inputValue) {
      inputValue = inputValue === 'Active' ? true : inputValue;
    }
  }

}
